import getInterruptions from './interruptions';
import getStatus from './status';

export default {
  getInterruptions,
  getStatus,
};
